import { lazy } from "react";
import { createBrowserRouter, createMemoryRouter, Navigate } from "react-router-dom";

import Layouts from "../layouts/index";
import { CDCProvider } from "../contexts/CDCContext";

const Template = lazy(() => import("../pages/notification/Template"));
const Payload = lazy(() => import("../pages/notification/Payloads"));
const Task = lazy(() => import("../pages/notification/Tasks"));
const History = lazy(() => import("../pages/notification/History"));

const routesForm = [
  {
    path: "/notification",
    element: (
      <CDCProvider>
        <Layouts />
      </CDCProvider>
    ),
    children: [
      {
        path: '',
        element: <Navigate to='/notification/templates' />
      },
      {
        path: '/notification/templates',
        element: <Template />
      },
      {
        path: '/notification/payloads',
        element: <Payload />
      },
      {
        path: '/notification/tasks',
        element: <Task />
      },
      {
        path: '/notification/history',
        element: <History />
      },
      {
        path: '/notification/records/:recordId',
        element: <History />,
      },
    ]
  },
  {
    path: "/*",
    element: <Navigate to="/notification/templates" />,
  },
];

const isEmbeddedMode = (() => {
  try {
    return window.parent !== window;
  } catch (error) {
    return true;
  }
})();

const memoryInitialEntry = `${window.location.pathname}${window.location.search}${window.location.hash}`;

const Router = isEmbeddedMode
  ? createMemoryRouter(routesForm, {
      initialEntries: [memoryInitialEntry],
    })
  : createBrowserRouter(routesForm);

export { Router };
